import { Injectable, ComponentRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  ArgosAlertService,
  ArgosAlertComponent,
  Notification
} from '@core-argos-angular-artifact/components';

export type NotificationComponent = ArgosAlertComponent;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private readonly alertService: ArgosAlertService,
    private readonly translate: TranslateService
  ) {}

  showErrorNotification(
    notification: Notification,
    params?: any
  ): ComponentRef<ArgosAlertComponent> {
    const notificationCopy = { ...notification };

    notificationCopy.text = params
      ? this.translate.instant(notification.text, params)
      : this.translate.instant(notification.text);

    if (notification.textAction) {
      notificationCopy.textAction = this.translate.instant(
        notification.textAction
      );
    }

    return this.alertService.showErrorNotification(notificationCopy);
  }

  showSuccessNotification(
    notification: Notification,
    params?: any
  ): ComponentRef<ArgosAlertComponent> {
    const notificationCopy = { ...notification };

    notificationCopy.text = params
      ? this.translate.instant(notification.text, params)
      : this.translate.instant(notification.text);

    return this.alertService.showSuccessNotification(notificationCopy);
  }

  clearNotifications(): void {
    this.alertService.clearNotifications();
  }
}
